module.exports = __webpack_public_path__ + "static/media/Rachael_Wendy_2025.8762d638.jpg";